<h2 mat-dialog-title>Reveal full SSNs</h2>

<mat-dialog-content class="dialog-content">
  <div class="sensitive-warning sensitive-warning--reveal">
    <mat-icon>visibility</mat-icon>
    <div>
      <strong>Full SSNs will be displayed</strong>
      <p>
        Reveal {{ data.reportName }} only when the full value is required for the approved purpose below. Do not copy it into notes, messages, or downloads.
      </p>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field appearance="outline">
      <mat-label>Business purpose</mat-label>
      <mat-select formControlName="businessPurposeCode">
        <mat-option value="" disabled>Select a purpose</mat-option>
        <mat-option *ngFor="let purpose of data.businessPurposes" [value]="purpose.code">{{ purpose.label }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('businessPurposeCode')?.hasError('required')">Business purpose is required.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Reference type</mat-label>
      <mat-select formControlName="referenceType">
        <mat-option value="" disabled>Select a reference type</mat-option>
        <mat-option *ngFor="let option of referenceTypes" [value]="option.value">{{ option.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Reference ID</mat-label>
      <input matInput formControlName="referenceId" autocomplete="off" />
      <mat-hint>Enter the approved identifier. Example: MM-5485.</mat-hint>
      <mat-error *ngIf="form.get('referenceId')?.hasError('required')">Reference ID is required.</mat-error>
      <mat-error *ngIf="form.get('referenceId')?.hasError('pattern')">Use letters, numbers, and @ . _ : + - only.</mat-error>
    </mat-form-field>

    <mat-checkbox formControlName="revealConfirmed" class="reveal-confirmation">
      I confirm that viewing full SSNs is required for this approved business purpose.
    </mat-checkbox>
    <mat-error class="confirmation-error" *ngIf="form.get('revealConfirmed')?.touched && form.get('revealConfirmed')?.invalid">
      Confirm the business need before revealing full SSNs.
    </mat-error>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-raised-button
    color="warn"
    type="button"
    [disabled]="form.invalid"
    (click)="submit()"
  >
    Reveal full SSNs
  </button>
</mat-dialog-actions>
